
import React from 'react';
import type { Screenshot } from './types';
import ScreenshotCaption from './ScreenshotCaption';
import IPhoneFrame from './iPhoneFrame';

interface ScreenshotCardProps {
  screenshot: Screenshot;
  isMobile?: boolean;
}

const ScreenshotCard: React.FC<ScreenshotCardProps> = ({ 
  screenshot, 
  isMobile = false 
}) => {
  const cardClasses = isMobile 
    ? "w-full"
    : "ios-card overflow-hidden";

  const innerCardClasses = isMobile 
    ? "ios-card overflow-hidden flex flex-col items-center"
    : "";

  return (
    <div className={cardClasses}>
      <div className={innerCardClasses}>
        <ScreenshotCaption 
          title={screenshot.title}
          description={screenshot.description}
          isMobile={isMobile}
        />
        
        <IPhoneFrame 
          image={screenshot.image}
          alt={screenshot.alt}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default ScreenshotCard;
